import React from 'react';
import { useDispatch } from 'react-redux';
import {
  changeAssignedNutritionistId,
  changeAssignNutritionistModalVisibility
} from '../../../store/memberSlice';
import { NutritionistInMemberResponse } from '../../../types/apiGeneratedTypes';
type Props = {
  nutritionistData: NutritionistInMemberResponse | null;
};

const AssignedNutritionist = ({ nutritionistData }: Props) => {
  const dispatch = useDispatch();
  return nutritionistData ? (
    <div
      className='assigned-doctor'
      onClick={() => {
        dispatch(
          changeAssignedNutritionistId(nutritionistData?.user_id || null)
        );
        dispatch(changeAssignNutritionistModalVisibility(true));
      }}
    >
      <div className='doctor-avatar'>
        <img src={nutritionistData?.photo_url!} alt='avatar' />
      </div>
      <div className='doctor-name-wrapper nutritionist-name-wrapper'>
        <div className='doctor-name'>{`${nutritionistData?.first_name} ${nutritionistData?.last_name}`}</div>
        <span className='name-info'>Assigned Nutritionist</span>
      </div>
    </div>
  ) : (
    <div className='main-member-info'>
      <div className='divider'></div>
      <div className='member-info'>
        <div className='info-label'>Nutritionist</div>
        <div className='info-value address'>
          <div>
            <div
              className='set-address'
              onClick={() =>
                dispatch(changeAssignNutritionistModalVisibility(true))
              }
            >
              Assign Nutritionist
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignedNutritionist;
